import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María García',
    age: 34,
    location: 'Buenos Aires, Argentina',
    quote: 'Me encanta lo fáciles que son las recetas. Siempre pensé que hacer budines era difícil, pero con este libro me salen perfectos y súper húmedos. ¡A mi familia le encantan!'
  }, {
    name: 'Carmen López',
    age: 42,
    location: 'Ciudad de México, México',
    quote: 'Compré el libro por curiosidad y terminé usando el bono para empezar a vender. Ahora tengo clientes fijos todas las semanas. Las recetas son económicas y rinden un montón.'
  }, {
    name: 'Lucía Fernández',
    age: 28,
    location: 'Madrid, España',
    quote: 'Sorprendí a toda mi familia el fin de semana. Hice el budín marmolado y no podían creer que lo había hecho yo. Las explicaciones son clarísimas.'
  }, {
    name: 'Ana Rodríguez',
    age: 51,
    location: 'Bogotá, Colombia',
    quote: 'Nunca había cocinado nada dulce en mi vida. Seguí el paso a paso del budín de limón y me quedó espectacular. La guía de equivalencias me salvó la vida.'
  }, {
    name: 'Patricia Morales',
    age: 38,
    location: 'Santiago, Chile',
    quote: 'Solo por los bonos ya vale la pena pagar ese precio. El recetario de budines salados es una maravilla para las cenas rápidas. 100% recomendado.'
  }];
  return <section className="py-20 px-4 bg-[#FFF8F0]" data-id="element-181">
      <div className="max-w-6xl mx-auto" data-id="element-182">
        <div className="text-center mb-16" data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#3D2B1F]" data-id="element-184">
            Miles de personas ya están preparando{' '}
            <span className="text-[#D4850A]" data-id="element-185">budines increíbles</span>
          </h2>
          <p className="text-xl text-[#9B8578]" data-id="element-186">
            Mirá lo que dicen quienes ya tienen el libro
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-187">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl border border-[#E8D5C4] flex flex-col shadow-md" data-id="element-188">
              <div className="flex gap-1 mb-4" data-id="element-189">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#D4850A] fill-[#D4850A]" data-id="element-190" />)}
              </div>
              <p className="text-[#6B5344] italic mb-6 flex-1 text-lg" data-id="element-191">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-[#E8D5C4] pt-4" data-id="element-192">
                <p className="font-bold text-[#3D2B1F] text-lg" data-id="element-193">
                  {testimonial.name}, {testimonial.age}
                </p>
                <p className="text-sm text-[#9B8578]" data-id="element-194">{testimonial.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}